import { render } from "./DocumentApprovalList.vue?vue&type=template&id=5b4cd06c&scoped=true"
import script from "./DocumentApprovalList.vue?vue&type=script&lang=js"
export * from "./DocumentApprovalList.vue?vue&type=script&lang=js"

import "./DocumentApprovalList.vue?vue&type=style&index=0&id=5b4cd06c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4cd06c"]])

export default __exports__